import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="https://i.hizliresim.com/f6a4pue.png"
								alt="Monster Notebook"
								className="work-image"
							/>
							<div className="work-title">Monster Notebook</div>
							<div className="work-subtitle">
								Frontend Developer ( Intern )
							</div>
							<div className="work-duration">2022 Aug - Oct</div>
						</div>

						<div className="work">
							<img
								src="https://avatars.githubusercontent.com/u/109578564?s=100&v=4"
								alt="Freelance"
								className="work-image"
							/>
							<div className="work-title">Freelance</div>
							<div className="work-subtitle">
								Software Developer
							</div>
							<div className="work-duration">2022 - Present</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
